var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var DotsVertical = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ width: '2', height: '10', viewBox: '0 0 2 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1ZM0 5C0 4.44772 0.447715 4 1 4C1.55228 4 2 4.44772 2 5C2 5.55228 1.55228 6 1 6C0.447715 6 0 5.55228 0 5ZM0 9C0 8.44772 0.447715 8 1 8C1.55228 8 2 8.44772 2 9C2 9.55229 1.55228 10 1 10C0.447715 10 0 9.55229 0 9Z', fill: '#212A3D' }) })));
};
export { DotsVertical };
//# sourceMappingURL=DotsVertical.js.map